import { useEffect, useMemo, useState } from "react";
import { AppModal } from "../../_CORE/APP/Templates/_UI/Modal/_index";
import { AppButton } from "../../_CORE/APP/Templates/_UI/Button/_index";
import "./_Styles/RecordExportPicker.css";

export const RecordExportPickerModal = ({
    isOpen = false,
    columns = [],
    selectedKeys = [],
    onClose,
    onApply,
}) => {
    const EXPORTABLE = useMemo(() => (columns ?? []).filter((column) => column?.isExportable !== false), [columns]);
    const [selection, setSelection] = useState({});

    useEffect(() => {
        if (!isOpen) return;
        const allowed = new Set(EXPORTABLE.map((column) => column.key));
        const current = (selectedKeys ?? []).filter((key) => allowed.has(key));
        const effective = current.length ? current : EXPORTABLE.map((column) => column.key);
        setSelection(Object.fromEntries(EXPORTABLE.map((column) => [column.key, effective.includes(column.key)])));
    }, [isOpen, EXPORTABLE, selectedKeys]);

    const picked = EXPORTABLE.filter((column) => !!selection[column.key]).map((column) => column.key);

    return (
        <AppModal isOpen={isOpen} onClose={onClose} size="md"
            title="Elegir columnas"
            description="Marcá únicamente los campos que querés guardar. La selección se usa para CSV, Excel, PDF e impresión."
            footer={<>
                <AppButton variant="ghost" tone="neutral" onClick={onClose}>Cancelar</AppButton>
                <AppButton isDisabled={picked.length === 0} onClick={() => onApply?.(picked)}>Aplicar columnas</AppButton>
            </>}>
            <div className="LStudio__app_record_export_picker">
                <div className="LStudio__app_record_export_picker_actions">
                    <AppButton size="sm" variant="ghost" tone="neutral"
                        onClick={() => setSelection(Object.fromEntries(EXPORTABLE.map((column) => [column.key, true])))}>
                        Seleccionar todo
                    </AppButton>
                    <AppButton size="sm" variant="ghost" tone="neutral"
                        onClick={() => setSelection(Object.fromEntries(EXPORTABLE.map((column) => [column.key, false])))}>
                        Ninguno
                    </AppButton>
                </div>
                <div className="LStudio__app_record_export_picker_list">
                    {EXPORTABLE.map((column) => (
                        <label key={column.key} className="LStudio__app_record_export_picker_item">
                            <input type="checkbox" checked={!!selection[column.key]}
                                onChange={(event) => setSelection((current) => ({ ...current, [column.key]: event.target.checked }))} />
                            <span>{column.label}</span>
                        </label>
                    ))}
                </div>
            </div>
        </AppModal>
    );
};
